import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const me = async () => {
  const res = await httpRequest.get("/2fa/auth/me");

  return res;
};

export const verify = async (id: string) => {
  const res = await httpRequest.get(`/2fa/auth/${id}/verify`);
  return res;
};

export const login = async (data: any) => await httpRequest.post(`/2fa/auth/login`, data, { silent: true });

// Redeems the one-time handoff code from /auth/gate-hub?code=. Same response shape as login.
export const gateExchange = async (code: string) =>
  await httpRequest.post(`/2fa/auth/oidc/exchange`, { code }, { silent: true });

// Ends the Gate Hub session too; only valid for sessions started via Gate Hub.
export const gateLogout = async () => await httpRequest.post(`/2fa/auth/oidc/logout`, {}, { silent: true });

// Links a Gate Hub identity to an existing DeHUB account after password confirmation.
export const gateLink = async (code: string, username: string, password: string) =>
  await httpRequest.post(`/2fa/auth/oidc/link`, { code, username, password }, { silent: true });

export const logout = async () => await httpRequest.get("/2fa/auth/logout");

export const forgot = async (data: any) => await httpRequest.put(`/2fa/auth/forgot`, data, { silent: true });

export const createPin = async (data: any) => await httpRequest.post(`/2fa/auth/pin`, data);

export const updatePin = async (data: any) => await httpRequest.put(`/2fa/auth/pin`, data);

export const forgotPin = async (data: { password: string }) => await httpRequest.post(`/2fa/auth/pin/forgot`, data);

export const verifyPinOtp = async (data: { otpCode: string }) => await httpRequest.post(`/2fa/auth/otp/verify-pin`, data);

export const resetPin = async (data: { pin: string }) => await httpRequest.post(`/2fa/auth/pin/reset`, data);

export const test = async () => await httpRequest.get(`/2fa/auth/test`);

export const updateAvatar = async (data: any) => await httpRequest.put("/2fa/auth/profile/avatar", data);

export const dan = async (redirect?: string) => await httpRequest.get(`/2fa/auth/profile/dan_verify`, redirect ? { redirect } : undefined);

export const danVerify = async (data: { code: string; expires?: string | number; state: string }) => await httpRequest.get(`/2fa/auth/profile/dan`, data, { silent: true });

export const changePassword = async (data: any) => await httpRequest.post("/2fa/auth/password/change", data);

export const updateProfile = async (data: any) => await httpRequest.put(`/2fa/auth/profile`, data);

// Latin display name only. Separate from updateProfile because that endpoint
// rewrites the Cyrillic name of record and is closed to DAN-verified users.
export const updateNameLatin = async (data: { firstNameLatin?: string; lastNameLatin?: string }) =>
  await httpRequest.put(`/2fa/auth/profile/name-latin`, data);

export const businessLogin = async (data: any, extras?: { silent?: boolean }) =>
  await httpRequest.post(`/2fa/auth/business-login`, data, extras);

export const businessLogout = async (data: any) => await httpRequest.get(`/2fa/auth/business-logout`, data);

export const nextLogin = async (data: { uid: string }) => await httpRequest.post(`/2fa/auth/next-login`, data);

// silent: NextLoginForm maps the backend error codes (NEXT_EMPLOYEE_NOT_IMPORTED,
// directory unreachable, wrong credentials) to its own messages — the http-handler
// auto-toast would otherwise show the raw backend message alongside it.
export const nextPasswordLogin = async (data: { uid: string; password: string }) =>
  await httpRequest.post(`/2fa/auth/next-password-login`, data, { silent: true });

export const nextVerify = async (data: { otpCode: string }) => await httpRequest.post(`/2fa/auth/next-verify`, data);
